import React, { memo } from 'react'
import { InfoBox, Text, Col } from '@evertel/web/ui'

export interface UnknownWidgetProps {
    id: number|string
    value: string
    title: string
    required?: boolean
    scope?: string
    /** Layout classes (e.g. `p-4 col-sm-12`) computed by the parent Row */
    className?: string
}

const UnknownWidget: React.FC<UnknownWidgetProps> = memo(({
    title,
    className
}) => {

    // the Col carries the row's layout classes: a non-list Row applies m-n4 and relies
    // on each child's p-4 to cancel it, so dropping className would collapse the row
    return (
        <Col valign="top" className={className}>
            <InfoBox color="info">
                <Text>
                    {`To view this ${title} field, you must update your app`}
                </Text>
            </InfoBox>
        </Col>
    )
})

export {
    UnknownWidget
}
